var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"mb-4"},[_c('a',{staticClass:"group text-white hover:text-white hover:font-bold uppercase flex no-underline text-md md:text-xl leading-normal",attrs:{"href":_vm.url},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"group-hover:underline flex-grow"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }